<template>
  <el-card style="height: 100%" class="box-card" body-style="height:86%">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <el-row>
        <el-col :span="10">
          <span style="font-size: 24px">{{
            JSON.parse(this.$UrlEncode.decode(this.$route.query.key)).name
          }}</span>
        </el-col>
        <el-col :span="14">
          <el-row>
            <el-col :span="3">
              <el-select
                v-model="stateType"
                placeholder="请选择"
                @change="stateChange"
              >
                <el-option
                  v-if="ApplyType != 2"
                  v-for="(item, index) in options1"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
                <el-option
                  v-if="ApplyType == 2"
                  v-for="(item, index) in options4"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button
                style="width: 100%"
                :type="ApplyType == 1 ? 'warning' : 'primary'"
                @click="applyType(1)"
                >我发起的</el-button
              >
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button
                style="width: 100%"
                :type="ApplyType == 2 ? 'warning' : 'primary'"
                @click="applyType(2)"
                >待处理</el-button
              >
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button
                style="width: 100%"
                :type="ApplyType == 3 ? 'warning' : 'primary'"
                @click="applyType(3)"
                >已处理</el-button
              >
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button
                style="width: 100%"
                :type="ApplyType == 4 ? 'warning' : 'primary'"
                @click="applyType(4)"
                >抄送给我</el-button
              >
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button
                style="width: 100%"
                type="primary"
                plain
                @click="addflowChart"
                >新增</el-button
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-table
      height="72vh"
      class="table"
      :data="formApplyList"
      :key="ApplyType"
      :row-class-name="tableRowClassName"
      v-loading="loading"
    >
      <el-table-column align="center" label="" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.famp13 == 1" style="color: red">催！</span>
          <span v-if="scope.row.isovertime == '已逾期'" style="color: red">{{
            scope.row.isovertime
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        type="index"
        label="序号"
      ></el-table-column>
      <el-table-column align="center" prop="fmap03" label="表单名称">
      </el-table-column>
      <el-table-column align="center" prop="fmtp03" label="模版名称">
      </el-table-column>
      <el-table-column align="center" prop="isovertime" label="重要程度">
        <template slot-scope="scope">
          {{ scope.row.fmtp09 == 1 ? "一般" : "重大" }}
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        prop="user04"
        label="创建人"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="famp10"
        label="创建时间"
      ></el-table-column>
      <el-table-column align="center" prop label="状态">
        <template slot-scope="scope">
          <span>
            {{
              scope.row.famp11 == 1
                ? "进行中"
                : scope.row.famp11 == 2
                ? "已通过"
                : scope.row.famp11 == 3
                ? "未通过"
                : "已撤回"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        width="300"
        align="center"
        prop
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            v-if="ApplyType != 2"
            @click="editFormApply(scope.row.fmap01)"
            type="primary"
            size="mini"
            >详情</el-button
          >
          <el-button
            v-if="ApplyType == 1 && scope.row.famp11 == 1"
            @click="PressFormApply(scope.row.fmap01)"
            :type="scope.row.famp13 == 0 ? 'warning' : 'info'"
            size="mini"
            :disabled="scope.row.famp13 == 1"
            >{{ scope.row.famp13 == 0 ? "催办" : "已催" }}</el-button
          >
          <el-button
            v-if="ApplyType == 1 && scope.row.famp11 == 4"
            @click="selFormApply(scope.row.fmap01, 1)"
            type="primary"
            size="mini"
            >编辑</el-button
          >
          <el-button
            v-if="ApplyType == 2"
            @click="selFormApply(scope.row.fmap01, 2)"
            type="primary"
            size="mini"
            >查看</el-button
          >
          <el-popconfirm
            style="margin-left: 10px"
            confirm-button-text="好的"
            cancel-button-text="不用了"
            icon="el-icon-info"
            icon-color="red"
            @confirm="DelFormApply(scope.row.fmap01)"
            title="确定删除吗？"
          >
            <el-button
              v-show="
                ApplyType == 1 &&
                (scope.row.famp11 == 4 || scope.row.famp11 == 3)
              "
              slot="reference"
              type="danger"
              size="mini"
              >删除</el-button
            >
          </el-popconfirm>
          <el-popconfirm
            v-show="ApplyType == 1 && scope.row.famp11 == 1"
            style="margin-left: 10px"
            confirm-button-text="好的"
            cancel-button-text="不用了"
            icon="el-icon-info"
            icon-color="red"
            @confirm="CancelFormApply(scope.row.fmap01)"
            title="确定撤回吗？"
          >
            <el-button slot="reference" size="mini" type="info">撤回</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 20px"
      align="center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <!-- 新增 -->
    <el-dialog
      top="1%"
      title="新增"
      :visible.sync="addFormApplyOpen"
      :before-close="handleClose"
      width="90%"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="选择自定义表单模版" name="first">
          <el-row>
            <el-col :span="11" style="padding-right: 20px">
              <el-descriptions class="margin-top" :column="1" border>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-user"></i>
                    选择表单模版
                  </template>
                  <el-select
                    style="width: 100%"
                    v-model="functionTempId"
                    @change="changeFormTemp"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in formTemplist"
                      :key="index"
                      :label="item.fmtp03"
                      :value="item.fmtp01"
                    ></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-user"></i>
                    输入表单名称
                  </template>
                  <el-input v-model="functionName"></el-input>
                </el-descriptions-item>
              </el-descriptions>
            </el-col>
            <el-col :span="13" style="height: 90vh">
              <iframe
                v-if="formTemp.fmtp05"
                :src="this.$store.state.baseUrl + formTemp.fmtp05"
                width="100%"
                height="100%"
                frameborder="0"
              ></iframe>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane
          :disabled="functionTempId == null || functionName == ''"
          label="内容完善填写"
          name="second"
        >
          <el-row>
            <el-col :span="12" style="padding-right: 20px">
              <el-descriptions class="margin-top" :column="1" border>
                <el-descriptions-item
                  v-for="(item, index) in tempFields"
                  :key="index"
                >
                  <template slot="label">{{ item.fmfd06 }}</template>
                  <!-- 根据 要填写的类型不同，所需要填写的组建不同 -->
                  <!-- 类型指定（1文本 2音频 3视频 4表单编号 5金额 6是否选择项 
                    7填表人员 8提交时间 9附件 10视点 11选择集 12图片） -->
                  <!-- 占用 02 -->
                  <!--提交时间8-->
                  <el-date-picker
                    :disabled="true"
                    v-if="item.fmfd04 == 8"
                    value-format="yyyy/MM/dd HH:mm:ss"
                    v-model="item.fmfd02"
                    type="datetime"
                    placeholder="选择日期时间"
                  ></el-date-picker>

                  <!-- 文本 地址 电话号码 金额-->
                  <el-input
                    v-model="item.fmfd02"
                    v-if="item.fmfd04 == 1"
                  ></el-input>
                  <!-- 自动编号 如果选择了自动编号，则会自动生成 v-model="item.fmfd02"-->
                  <el-input
                    v-model="item.fmfd02"
                    v-if="item.fmfd04 == 4"
                    :disabled="true"
                  ></el-input>
                  <el-input-number
                    v-model="item.fmfd02"
                    v-if="item.fmfd04 == 5"
                    :precision="2"
                    :step="0.1"
                  ></el-input-number>
                  <!-- 是否选择项 -->
                  <el-radio-group v-if="item.fmfd04 == 6" v-model="item.fmfd02">
                    <el-radio label="是">是</el-radio>
                    <el-radio label="否">否</el-radio>
                  </el-radio-group>
                  <!-- 人员 -->
                  <el-input
                    v-model="item.fmfd02"
                    v-if="item.fmfd04 == 7"
                    :disabled="true"
                  ></el-input>

                  <!-- 印章 签名 图片-12 视频-3 语音-2 附件-9-->

                  <el-upload
                    ref="auploadOne"
                    v-if="
                      item.fmfd04 == 12 ||
                      item.fmfd04 == 3 ||
                      item.fmfd04 == 2 ||
                      item.fmfd04 == 9
                    "
                    class="upload-demo"
                    action="/"
                    :on-change="(file) => changeFile(item, file)"
                    :on-remove="(file) => changeFile(item, file, 1, 2)"
                    :limit="1"
                    :accept="
                      item.fmfd04 == 12
                        ? '.jpg,.png,.jpeg'
                        : item.fmfd04 == 3
                        ? '.mp4,mov'
                        : item.fmfd04 == 2
                        ? '.mp3'
                        : ''
                    "
                    :auto-upload="false"
                  >
                    <el-button slot="trigger" size="small" type="text"
                      >选取文件</el-button
                    >
                  </el-upload>
                  <!-- 选择集-11 视点-10 -->
                  <el-button
                    v-if="item.fmfd04 == 10 || item.fmfd04 == 11"
                    type="text"
                    @click="changeModelOrView(item, 1)"
                    >{{
                      item.fmfd04 == 10 ? "请选择视点" : "请选择选择集"
                    }}</el-button
                  >
                  <img
                    style="width: 100px"
                    v-if="
                      item.fmfd02 && (item.fmfd04 == 10 || item.fmfd04 == 11)
                    "
                    @click="viewImage(item.fmfd02 ? item.fmfd02 : item.fafd06)"
                    :src="
                      item.fmfd02
                        ? $store.state.baseUrl + item.fmfd02
                        : $store.state.baseUrl + item.fafd06
                    "
                  />
                </el-descriptions-item>
              </el-descriptions>
              <el-button
                @click="AddFormApply"
                style="float: right; margin-top: 10px; width: 100px"
                type="primary"
                size="samll"
                >发布</el-button
              >
            </el-col>
            <el-col :span="12" style="height: 90vh">
              <iframe
                v-if="formTemp.fmtp05"
                :src="this.$store.state.baseUrl + formTemp.fmtp05"
                width="100%"
                height="100%"
                frameborder="0"
              ></iframe>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      top="1%"
      title="表单详情"
      :visible.sync="editFormApplyOpen"
      :before-close="handleClose"
      width="90%"
    >
      <el-button
        type="primary"
        @click="ExportFile(FormApply)"
        style="float: right; margin-bottom: 5px"
        >打印导出</el-button
      >
      <hr />
      <el-row class="decrad">
        <el-col :span="10" :offset="0" style="height: 90vh">
          <div style="display: flex; justify-content: space-between">
            <el-button type="text" @click="lookForm(FormApplySafeFields)">
              <i class="el-icon-view"></i>查看表单内容
            </el-button>
          </div>
          <iframe
            :src="this.$store.state.baseUrl + FormApply.famp06"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </el-col>
        <el-col :span="7" :offset="0" style="padding-left: 10px">
          <div class="middle">
            <el-card class="box-card" shadow="never" style="height: 45vh">
              <div slot="header" class="clearfix">
                <span style="font-size: 18px; font-weight: bold">协同流程</span>
              </div>
              <div
                style="height: 35vh; overflow: auto; background-color: #f3f5f6"
              >
                <div
                  style="margin-left: 10%; margin-top: 8%; width: 80%"
                  v-for="(item, index) in FormAuditFlow.filter(
                    (ele) => ele.fmad07 == 1
                  )"
                  :key="index"
                >
                  <el-card class="box-card" shadow="always">
                    <p style="color: #527cfa" v-if="item.fmad05 == 1">会签</p>
                    <p style="color: #527cfa" v-else>或签</p>
                    <div class="card-cont">
                      <h4>步骤{{ item.fmad06 }}（{{ item.fmad03 }}）</h4>
                      <span>{{ item.name }}</span>
                    </div>
                  </el-card>
                  <i
                    v-if="
                      index !=
                      FormAuditFlow.filter((ele) => ele.fmad07 == 1).length - 1
                    "
                    class="el-icon-bottom"
                  ></i>
                </div>

                <div
                  style="margin-left: 5%; margin-top: 8%; width: 80%"
                  class="el-card__body"
                  v-for="(item, index) in FormAuditFlow.filter(
                    (ele) => ele.fmad07 == 2
                  )"
                  :key="item.fmad01"
                >
                  <el-card class="card-son" shadow="always">
                    <p style="color: #527cfa">抄送人员</p>
                    <div class="card-cont">
                      <span>{{ item.name }}</span>
                    </div>
                  </el-card>
                </div>
              </div>
            </el-card>
            <el-card
              class="box-card goutong"
              shadow="never"
              style="height: 49vh"
            >
              <div slot="header" class="clearfix">
                <span style="font-size: 18px; font-weight: bold">沟通记录</span>
              </div>
              <el-row>
                <el-col :span="19">
                  <el-input
                    placeholder="请输入内容"
                    v-model="talkSafe"
                    clearable
                  >
                  </el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-button type="primary" @click="talkhanld">评论</el-button>
                </el-col>
              </el-row>
              <div style="height: 36vh; overflow: auto; margin-top: -20px">
                <div
                  v-for="(item, index) in safeList"
                  :key="index"
                  class="text item"
                >
                  <el-card
                    class="box-card"
                    style="margin: 0 auto; width: 90%; margin-top: 20px"
                  >
                    <el-row>
                      <el-col :span="4">
                        <el-avatar
                          v-if="item.imgurl"
                          :size="50"
                          :src="$store.state.baseUrl + item.imgurl"
                        ></el-avatar>
                        <el-avatar
                          v-else
                          src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                        ></el-avatar>
                      </el-col>
                      <el-col :span="19" :offset="1">
                        <div>
                          <span style="font-size: 18px; font-weight: bold">{{
                            item.Username
                          }}</span>
                          <span
                            style="
                              font-size: 12px;
                              margin-left: 20px;
                              color: #a6a6a6;
                            "
                            >{{ item.fscd05 }}</span
                          >
                        </div>
                        <div style="margin-top: 8px">{{ item.fscd03 }}</div>
                        <div>
                          <el-popconfirm
                            v-show="item.fscd04 == talkId"
                            confirm-button-text="好的"
                            cancel-button-text="不用了"
                            icon="el-icon-info"
                            icon-color="red"
                            title="确定删除吗？"
                            @confirm="delTalk(item.fscd01)"
                          >
                            <el-button
                              type="text"
                              slot="reference"
                              style="float: right; color: #909399"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </el-col>
                    </el-row>
                  </el-card>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="7" :offset="0">
          <el-card class="box-card" shadow="never" style="margin-top: -20px">
            <div slot="header" class="clearfix">
              <span style="font-size: 18px; font-weight: bold">动态记录</span>
            </div>
            <div style="height: 83vh; overflow: auto">
              <!-- 内容 -->
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in FormAuditRecord"
                  :key="index"
                  :icon="activity.icon"
                  :type="activity.type"
                  :color="activity.color"
                  :size="activity.size"
                  :timestamp="activity.farc05"
                >
                  <p>
                    {{ activity.farc03 }}
                    <el-button
                      style="margin-left: 100px"
                      type="primary"
                      size="mini"
                      @click="(bhUrl = null), (bhUrl = activity.farc07)"
                      v-if="activity.farc07"
                      >查看</el-button
                    >
                  </p>
                  <p
                    v-if="activity.farc06 && activity.farc06 != 'null'"
                    style="margin-top: 10px"
                  >
                    审批内容：{{ activity.farc06 }}
                  </p>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 编辑和查看  -->
    <el-dialog
      top="1%"
      :title="ApplyType == 2 ? '查看' : '编辑'"
      :visible.sync="updateFormApplyOpen"
      :before-close="handleClose"
      width="90%"
    >
      <!-- 只可编辑填写内容 不可编辑选择的模版和流程 -->
      <!-- 撤回状态  -->
      <el-button
        @click="UpdateFormApply"
        type="primary"
        size="mini"
        v-show="ApplyType == 1 && FormApplyState == 4"
        >提交</el-button
      >

      <el-popconfirm
        style="margin-left: 20px"
        confirm-button-text="好的"
        cancel-button-text="不用了"
        icon="el-icon-info"
        icon-color="red"
        @confirm="SubmitAudit(1)"
        title="确定提交？"
      >
        <el-button
          v-show="ApplyType == 2 && FormApplyState === 1"
          slot="reference"
          type="primary"
          :loading="btnloading"
          size="mini"
          >同意</el-button
        >
      </el-popconfirm>

      <el-tooltip
        class="item"
        effect="light"
        content="结束流程，表单未通过"
        placement="top"
      >
        <el-popconfirm
          style="margin-left: 10px"
          confirm-button-text="好的"
          cancel-button-text="不用了"
          icon="el-icon-info"
          icon-color="red"
          @confirm="SubmitAudit(2)"
          title="确定拒绝？"
        >
          <el-button
            type="danger"
            v-show="ApplyType == 2 && FormApplyState === 1"
            slot="reference"
            size="mini"
            >拒绝</el-button
          >
        </el-popconfirm>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        :content="'驳回到<' + boHuiStep.fmad03 + '>，流程继续。'"
        placement="top"
      >
        <el-popconfirm
          style="margin-left: 10px"
          confirm-button-text="好的"
          cancel-button-text="不用了"
          icon="el-icon-info"
          icon-color="red"
          @confirm="SubmitTurndown(2)"
          title="确定驳回？"
        >
          <el-button
            slot="reference"
            v-show="ApplyType == 2 && processStep.fmad10 != null ? true : false"
            type="warning"
            size="mini"
            >驳回</el-button
          >
        </el-popconfirm>
      </el-tooltip>
      <div
        style="
          display: inline;
          margin-bottom: 20px;
          margin-left: 20px;
          color: #43a5ff;
          font-size: 16px;
          cursor: pointer;
        "
        @click="lookForm(ApplyFieldsInfo)"
      >
        <i class="el-icon-view"></i>查看表单内容
      </div>
      <div style="float: right; margin-right: 20px">
        <el-button
          size="mini"
          type="primary"
          style="margin-left: 10px"
          @click="openreviewpro"
          >查看协同流程</el-button
        >
        <el-button
          size="mini"
          type="primary"
          style="margin-left: 10px"
          @click="opencomrecords"
          >查看沟通记录</el-button
        >
        <el-button
          size="mini"
          type="primary"
          style="margin-left: 10px"
          @click="Auditrecord"
          >查看动态记录</el-button
        >
        <el-button
          size="mini"
          type="primary"
          style="margin-left: 10px"
          @click="ExportFile"
          >导出源文件</el-button
        >
      </div>
      <el-row>
        <el-col :span="12" style="padding-right: 20px">
          <el-descriptions
            v-if="formApplyDetil.FormApplyFields"
            class="margin-top"
            :column="1"
            border
          >
            <el-descriptions-item
              v-for="(item, index) in formApplyDetil.FormApplyFields"
              :key="index"
            >
              <template slot="label">{{ item.fafd05 }}</template>
              <!-- 类型指定（1文本 2音频 3视频 4表单编号 5金额 6是否选择项 
                    7填表人员 8提交时间 9附件 10视点 11选择集 12图片） -->
              <el-date-picker
                v-if="item.fafd03 == 8"
                value-format="yyyy/MM/dd HH:mm:ss"
                v-model="item.fafd06"
                type="datetime"
                placeholder="选择日期时间"
                disabled
              ></el-date-picker>
              <el-input
                v-model="item.fafd06"
                v-if="item.fafd03 == 1"
              ></el-input>
              <el-input
                v-model="item.fafd06"
                v-if="item.fafd03 == 4"
                disabled
              ></el-input>
              <el-input-number
                v-model="item.fafd06"
                v-if="item.fafd03 == 5"
                :precision="2"
                :step="0.1"
              ></el-input-number>
              <!-- 是否选择项 -->
              <el-radio-group v-if="item.fafd03 == 6" v-model="item.fafd06">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
              <!-- 人员 -->
              <el-input
                v-model="item.fafd06"
                v-if="item.fafd03 == 7"
                disabled
              ></el-input>

              <!-- 印章 签名 图片 图片-12 视频-3 语音-2 附件-9--->
              <el-upload
                ref="uploadFile"
                v-if="
                  item.fafd03 == 12 ||
                  item.fafd03 == 3 ||
                  item.fafd03 == 2 ||
                  item.fafd03 == 9
                "
                class="upload-demo"
                action="/"
                :on-change="(file) => changeFile(item, file, 2)"
                :on-remove="(file) => changeFile(item, file, 2, 2)"
                :accept="
                  item.fafd03 == 12
                    ? '.jpg,.png,.jpeg'
                    : item.fafd03 == 3
                    ? '.mp4,mov'
                    : item.fafd03 == 2
                    ? '.mp3'
                    : ''
                "
                :limit="1"
                :auto-upload="false"
              >
                <el-button slot="trigger" size="small" type="text"
                  >选取文件</el-button
                >
              </el-upload>
              <!-- 选择集 视点 -->
              <el-button
                v-if="item.fafd03 == 10 || item.fafd03 == 11"
                type="text"
                @click="changeModelOrView(item, 2)"
                >{{
                  item.fafd03 == 10
                    ? "请选择视点"
                    : item.fafd03 == 11
                    ? "请选择选择集"
                    : ""
                }}</el-button
              >
              <img
                style="width: 100px"
                v-if="
                  (item.fafd03 == 10 || item.fafd03 == 11) &&
                  item.fafd06 != null
                "
                @click="viewImage(item.fafd06)"
                :src="$store.state.baseUrl + item.fafd06"
              />
            </el-descriptions-item>
          </el-descriptions>
        </el-col>
        <el-col :span="12" style="height: 90vh">
          <iframe
            v-if="formApplyDetil.FormApply.famp06"
            :src="this.$store.state.baseUrl + formApplyDetil.FormApply.famp06"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog title="图片" :visible.sync="viewImageShow" width="50%">
      <img :src="$store.state.baseUrl + imageUrl" style="width: 100%" alt />
    </el-dialog>

    <!-- 查看动态记录 -->
    <el-drawer
      title="动态记录"
      :visible.sync="record"
      direction="rtl"
      :before-close="handleClose"
    >
      <!-- 内容 -->
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in formApplyDetil.FormAuditRecord"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
          :timestamp="activity.farc05"
          ><div>{{ activity.farc03 }}</div>
          <div
            style="padding: 10px 10px 10px 0"
            class="flexLR"
            v-if="activity.farc04 != 1"
          >
            <div v-if="activity.farc06">驳回内容：{{ activity.farc06 }}</div>
            <div v-if="activity.farc07 != null && activity.farc07.length">
              <el-button
                type="primary"
                size="mini"
                @click="(bhUrl = null), (bhUrl = activity.farc07)"
                >查看</el-button
              >
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </el-drawer>

    <!-- 查看驳回文件 -->
    <el-dialog title="驳回文档" :visible.sync="bhUrl" width="50%" top="5%">
      <iframe
        v-if="bhUrl"
        :src="this.$store.state.baseUrl + bhUrl"
        width="100%"
        height="700px"
        frameborder="0"
      ></iframe>
    </el-dialog>

    <!-- 查看协同流程 -->
    <el-dialog
      title="协同流程"
      :visible.sync="reviewprocess"
      width="25%"
      :before-close="handleClose"
    >
      <!-- 内容 -->
      <div
        class="dia-card"
        v-for="(item, index) in formApplyDetil.FormAuditFlow.filter(
          (ele) => ele.fmad07 == 1
        )"
        :key="index"
      >
        <el-card class="el-body" shadow="always">
          <p style="color: #527cfa" v-if="item.fmad05 == 1">会签</p>
          <p style="color: #527cfa" v-else>或签</p>
          <div class="card-cont">
            <h4>步骤{{ item.fmad06 }}（{{ item.fmad03 }}）</h4>
            <span>{{ item.name }}</span>
          </div>
          <div class="div-span">
            <span
              v-if="item.state != ''"
              style="border: 1px solid #94c7fa; color: #94c7fa"
              >{{ item.state }}</span
            >
            <span v-else>{{ item.state }}</span>
          </div>
        </el-card>
        <i
          style="margin-left: 40px"
          v-if="index != formApplyDetil.FormAuditFlow.length - 1"
          class="el-icon-bottom"
        ></i>
      </div>
      <div
        class="dia-card"
        v-for="(item, index) in formApplyDetil.FormAuditFlow.filter(
          (ele) => ele.fmad07 == 2
        )"
        :key="item.fmad01"
      >
        <el-card class="card-son" shadow="always">
          <p style="color: #527cfa">抄送人员</p>
          <div class="card-cont">
            <span>{{ item.name }}</span>
          </div>
        </el-card>
      </div>
    </el-dialog>

    <!-- 查看表单内容 -->
    <el-dialog :visible.sync="lookFormShow" width="40%">
      <el-row>
        <el-descriptions class="margin-top" :column="1" border>
          <el-descriptions-item
            v-for="(item, index) in lookFromFields"
            :key="index"
          >
            <template slot="label">{{ item.fafd05 }}</template>
            <!-- 类型指定（1文本 2音频 3视频 4表单编号 5金额 6是否选择项 7填表人员 8提交时间 9附件 10视点 11选择集 12图片） -->
            <!-- 根据 要填写的类型不同，所需要填写的组建不同 -->
            <!-- 占用 02 -->
            <!-- 文本-->
            <el-input
              v-if="
                (item.fafd03 == 1 ||
                  item.fafd03 == 4 ||
                  item.fafd03 == 5 ||
                  item.fafd03 == 7 ||
                  item.fafd03 == 6 ||
                  item.fafd03 == 8) &&
                item.fafd06 != null
              "
              v-model="item.fafd06"
              :disabled="true"
            ></el-input>
            <!-- 附件 9-->
            <p v-else-if="item.fafd03 == 9 && item.fafd06 != null">
              {{ item.fafd06.slice(item.fafd06.lastIndexOf("/") + 1) }}
              <el-button
                @click="Office2Pdf(item)"
                size="small"
                type="primary"
                plain
                >查看</el-button
              >

              <el-button
                @click="
                  downLoad(
                    item.fafd06,
                    item.fafd06.slice(item.fafd06.lastIndexOf('/') + 1)
                  )
                "
                size="small"
                type="primary"
                plain
                >下载</el-button
              >
            </p>
            <!-- 图片 -->
            <img
              v-else-if="
                (item.fafd03 == 12 || item.fafd03 == 10 || item.fafd03 == 11) &&
                item.fafd06 != null
              "
              style="width: 320px; height: 240px"
              :src="$store.state.baseUrl + item.fafd06"
              alt=""
              srcset=""
            />
            <!-- 视频 -->
            <video
              v-else-if="item.fafd03 == 3 && item.fafd06 != null"
              width="320"
              height="240"
              controls
              autoplay
              :src="$store.state.baseUrl + item.fafd06"
            ></video>
            <!-- 音频 -->
            <audio
              v-else-if="item.fafd03 == 2 && item.fafd06 != null"
              :src="$store.state.baseUrl + item.fafd06"
              controls="controls"
            ></audio>
            <span v-else style="color: #909399; margin-left: 10px"
              >未上传数据</span
            >
          </el-descriptions-item>
        </el-descriptions>
      </el-row>
    </el-dialog>
    <el-dialog :visible.sync="ifromShow" width="40%" title="查看附件">
      <iframe style="width: 100%; height: 65vh" :src="fileLike"></iframe>
    </el-dialog>

    <!-- 查看沟通记录 -->
    <el-dialog
      title="沟通记录"
      :visible.sync="comrecords"
      width="25%"
      :before-close="handleClose"
    >
      <!-- 内容 -->
      <el-card class="box-card goutong" shadow="never" style="height: 49vh">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px; font-weight: bold">沟通记录</span>
        </div>
        <el-row>
          <el-col :span="19">
            <el-input placeholder="请输入内容" v-model="talkSafe" clearable>
            </el-input>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-button type="primary" @click="talkhanld">评论</el-button>
          </el-col>
        </el-row>
        <div style="height: 36vh; overflow: auto; margin-top: -20px">
          <div v-for="(item, index) in safeList" :key="index" class="text item">
            <el-card
              class="box-card"
              style="margin: 0 auto; width: 90%; margin-top: 20px"
            >
              <el-row>
                <el-col :span="4">
                  <el-avatar
                    v-if="item.imgurl"
                    :size="50"
                    :src="$store.state.baseUrl + item.imgurl"
                  ></el-avatar>
                  <el-avatar
                    v-else
                    src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                  ></el-avatar>
                </el-col>
                <el-col :span="19" :offset="1">
                  <div>
                    <span style="font-size: 18px; font-weight: bold">{{
                      item.Username
                    }}</span>
                    <span
                      style="font-size: 12px; margin-left: 20px; color: #a6a6a6"
                      >{{ item.fscd05 }}</span
                    >
                  </div>
                  <div style="margin-top: 8px">{{ item.fscd03 }}</div>
                  <div>
                    <el-popconfirm
                      v-show="item.fscd04 == talkId"
                      confirm-button-text="好的"
                      cancel-button-text="不用了"
                      icon="el-icon-info"
                      icon-color="red"
                      title="确定删除吗？"
                      @confirm="delTalk(item.fscd01)"
                    >
                      <el-button
                        type="text"
                        slot="reference"
                        style="float: right; color: #909399"
                        >删除</el-button
                      >
                    </el-popconfirm>
                    <!-- <el-button
                        type="text"
                        style="float: right;margin-right:10px"
                        @click="addTalk"
                        >评论</el-button
                      > -->
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </div>
      </el-card>
    </el-dialog>

    <!-- 视点选择集选择 -->
    <el-dialog title="选择节点" :visible.sync="modelOrView" width="60%">
      <el-row>
        <el-col :span="4">
          <zTree
            :zNodes="zNodes"
            :check="false"
            @getData="getData"
            :options="{
              id: 'ID',
              label: 'label',
              pid: 'ParentId',
              zTreeId: 'modelTree',
              delType: {
                add: false,
                update: false,
                del: false,
              },
            }"
          ></zTree>
        </el-col>
        <el-col :span="20">
          <el-table :data="selectOrViewList" style="width: 100%" height="770">
            <el-table-column prop="name" label="名字">
              <template slot-scope="scope">
                <el-button type="text" @click="bindPicForFmfdObj(scope.row)">{{
                  scope.row.name
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 查看选择集、视点 -->
    <el-dialog title="图片" :visible.sync="viewImageShow" width="50%">
      <img :src="$store.state.baseUrl + imageUrl" style="width: 100%" alt />
    </el-dialog>
  </el-card>
</template>

<script>
import {
  GetFormApply,
  PressFormApply,
  GetFullFormTemp,
  GetOneFormAuditFlow,
  AddFormApply,
  CancelFormApply,
  DelFormApply,
  FindFormApplyDetail,
  SubmitAudit,
  GetFormComment,
  AddFormComment,
  DelFormComment,
  GetOneFormTemps,
  UpdateFormApplys,
  SubmitTurndown,
  Office2Pdf,
  GetWorkPlaneTree2,
  FindWorkPlaneModel,
  GetModelSelectOrViewPoint,
} from "@/setAxios";
import { download } from "@/tools/tool";
import zTree from "@/components/zTree";
export default {
  components: { zTree },
  name: "dataList",
  data() {
    return {
      //选择集，视点---
      fmfdObj: {},
      modelOrView: false,
      zNodes: null,
      selectOrViewList: [],
      addOrEdit: 1,
      //选择集，视点---
      key: {},
      loading: false,
      options1: [
        {
          value: "null",
          label: "全部 ",
        },
        {
          value: "1",
          label: "进行中",
        },
        {
          value: "2",
          label: "已通过",
        },
        {
          value: "3",
          label: "未通过",
        },
        {
          value: "4",
          label: "已撤销",
        },
      ],
      options4: [
        {
          value: "null",
          label: "全部 ",
        },
      ],
      stateType: "null",
      searchword: "",
      formApplyList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      ApplyType: 1,
      activeName: "first",
      addFormApplyOpen: false,
      editFormApplyOpen: false,
      AddFormApplyParams: {
        name: "表单名称",
        tempId: "",
        qid: localStorage.pid,
      },
      formTemplist: [],
      formTemp: {},
      tempFields: [],
      AuditFlowList: [],
      detailList: [],
      AuditTempFields: [],
      formApplyDetil: {
        FormApply: {
          famp06: "",
        },
        FormAuditFlow: [],
      },
      // 详情数据
      FormApply: {},
      FormAuditFlow: [],
      FormAuditRecord: [], //动态记录
      FormApplySafeFields: [],
      updateFormApplyOpen: false,
      record: false, //打卡流程记录抽屉
      reviewprocess: false, //审核流程弹窗
      viewImageShow: false,
      imageUrl: "",
      SubmitAuditParams: {
        id: "",
        type: "",
        content: "",
        qid: localStorage.pid,
      },
      // 安全清单评论列表
      talkId: localStorage.id, //判断id
      talkSafe: "",
      safeList: [],
      safeId: null,
      talkInfo: {
        fscd01: "",
        fscd02: "",
        fscd03: "",
        fscd04: null,
        fscd05: new Date(),
      },
      // 查看表单内容
      lookFormShow: false,
      lookFromFields: [], // 表单内容数据
      comrecords: false,
      NewFormApplyFieldSafe: [], //获取最新表单模板字段值
      newApply: "",
      ApplyFieldsInfo: [],
      btnloading: false,
      functionName: "",
      functionTempId: null,
      processStep: {}, //流程步骤
      FormApplyState: null, //状态（1进行中  2已通过 3未通过 4已撤回）
      boHuiStep: {},
      bhUrl: null,
      ifromShow: false,
      fileLike: null,
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.key = JSON.parse(this.$UrlEncode.decode(this.$route.query.key));
        this.key.isTask?this.ApplyType=2:'';
        this.GetFormApply();
        this.GetFullFormTemp();
      },
      // 初始化执行一次
      immediate: true,
      // 深度观察监听
      deep: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    async Office2Pdf(data) {
      let res = await Office2Pdf({ sourcePath: data.fafd06 });
      if (res.Code === 0) {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      } else {
        this.ifromShow = true;
        this.fileLike = this.$store.state.baseUrl + res.Data;
      }
    },
    applyType(type) {
      this.loading = true;
      this.ApplyType = type;
      this.pageIndex = 1;
      this.GetFormApply();
    },
    viewImage(imageUrl) {
      this.viewImageShow = true;
      this.imageUrl = imageUrl;
    },
    ExportFile(FormApply) {
      var name = FormApply.famp07
        ? FormApply.famp07
        : this.formApplyDetil.FormApply.famp07;
      var path = FormApply.famp05
        ? FormApply.famp05
        : this.formApplyDetil.FormApply.famp05;
      this.downLoad(path, name + path.substr(path.lastIndexOf(".")));
    },
    downLoad(path, name) {
      try {
        download(
          this.$store.state.baseUrl + path,
          name + path.substr(path.lastIndexOf("."))
        );
      } catch (error) {
        this.$message.error("导出失败");
      }
    },
    // 获取表单申请列表
    async GetFormApply() {
      this.loading = true;
      //type: 1我发起的 2我审核的3我处理的 4我的抄送
      // state:状态（1进行中  2已通过 3未通过 4已撤销） ） 全部 null
      let params = {
        xid: localStorage.xid,
        uid: localStorage.id,
        type: this.ApplyType,
        searchword: this.searchword,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        tempId: JSON.parse(this.$UrlEncode.decode(this.$route.query.key)).type,
        state: this.stateType,
      };
      let res = await GetFormApply({ params });
      this.loading = false;
      this.formApplyList = res.Data.list;
      this.total = res.Data.total;
    },
    async getData(id) {
      if (id) {
        let findObj = this.zNodes.find((ele) => ele.ID == id);
        if (findObj.wopl07 !== 1) {
          this.$message.warning("只能选择单模");
        } else {
          let res = await FindWorkPlaneModel({ id });
          let modelId = res.Data.modelId;
          let res2 = await GetModelSelectOrViewPoint({
            mid: modelId,
            seachword: "",
            type:
              this.addOrEdit == 1
                ? this.fmfdObj.fmfd04 == 10
                  ? 3
                  : 1
                : this.fmfdObj.fafd03 == 10
                ? 3
                : 1,
            uid: localStorage.id,
          });
          this.selectOrViewList = res2.Data;
        }
      }
    },
    bindPicForFmfdObj(data) {
      if (data.pic) {
        if (this.addOrEdit == 1) {
          this.fmfdObj.fmfd02 = data.pic;
        } else {
          this.fmfdObj.fafd06 = data.pic;
        }
        this.modelOrView = false;
      } else {
        this.$message.warning("该选择集下无图片");
      }
    },
    async changeModelOrView(data, type) {
      this.selectOrViewList = [];
      this.addOrEdit = type;
      this.fmfdObj = data;
      this.modelOrView = true;
      let params = {
        xid: localStorage.getItem("xid"),
        pid: -1,
      };
      let res = await GetWorkPlaneTree2(params);
      this.zNodes = res.Data;
      this.zNodes.forEach((item) => {
        this.judge(item);
      });
    },
    // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    // 点击状态表格数据发生变化
    stateChange(stateType) {
      this.stateType = stateType;
      this.GetFormApply();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetFormApply();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetFormApply();
    },
    changeFormTemp(id) {
      this.formTemp = this.formTemplist.find((ele) => ele.fmtp01 == id);
      this.GetOneFormTemp(this.formTemp.fmtp01);
    },
    addflowChart() {
      let _this = this;
      this.addFormApplyOpen = true;

      // 初始化
      this.functionTempId = null;
      this.functionName = "";
      this.activeName = "first";
      this.tempFields = null;
      this.GetFullFormTemp();
    },
    async GetFullFormTemp() {
      let params = {
        xid: localStorage.xid,
        functempId: JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
          .type,
      };
      let res = await GetFullFormTemp({ params });
      if (res.Data.length) {
        this.formTemplist = res.Data;
        this.formTemp = res.Data[0];
        this.AddFormApplyParams.tempId = res.Data[0].fmtp01;
        this.GetOneFormTemp(this.formTemp.fmtp01);
      }
    },
    async CancelFormApply(id) {
      let res = await CancelFormApply({ id });
      if (res.Code) {
        this.$message.success("撤回成功");
        this.GetFormApply();
      }
    },
    async DelFormApply(id) {
      let res = await DelFormApply({ id, qid: localStorage.pid });
      if (res.Code) {
        this.$message.success("删除成功");
        this.GetFormApply();
      }
    },
    async GetOneFormAuditFlow(id) {
      let params = { id };
      let res = await GetOneFormAuditFlow({ params });
      //   fadt07 === 1 是流程 2 是抄送
      this.detailList = res.Data.detailList;
    },
    // 详情
    async editFormApply(id) {
      this.editFormApplyOpen = true;
      this.FindFormApplyDetail(id);
      this.GetFormComment(id);
      this.safeId = id;
    },
    // 获取表单申请详情
    async FindFormApplyDetail(id) {
      let params = {
        id,
      };
      let res = await FindFormApplyDetail({ params });
      this.FormApply = res.Data.FormApply;
      this.FormAuditFlow = res.Data.FormAuditFlow;
      this.FormAuditRecord = res.Data.FormAuditRecord;
      this.FormAuditRecord.forEach((ele) => {
        if (ele.farc04 == "2" || ele.farc04 == "3") {
          ele.size = "large";
          ele.type = "danger";
          ele.icon = "el-icon-circle-close";
        } else {
          ele.size = "large";
          ele.type = "primary";
          ele.icon = "el-icon-circle-check";
        }
      });
      this.FormApplySafeFields = res.Data.FormApplyFields; //详细内容
    },
    // 获取安全清单评论列表
    async GetFormComment(id) {
      let params = {
        id,
      };
      let res = await GetFormComment({ params });
      this.safeList = res.Data;
      let datestr = new Date().format("yyyy-MM-dd hh:mm");
      this.safeList.forEach((e) => {
        if (datestr == e.fscd05.toString().substring(0, 10)) {
          e.fscd05 =
            "今天" + e.fscd05.toString().substring(11, e.fscd05.length);
        }
      });
    },
    // 发送评论
    talkhanld() {
      this.talkInfo.fscd03 = this.talkSafe;
      this.talkInfo.fscd02 = this.safeId;
      this.talkInfo.fscd04 = Number(localStorage.id);
      let params = {
        model: this.talkInfo,
      };
      AddFormComment(params).then((res) => {
        if (res.Code) {
          this.$message.success("你已评论成功!");
          this.talkSafe = "";
          this.GetFormComment(this.safeId);
        }
      });
    },
    // 又一个评论
    addTalk() {
      this.$prompt("请输入评论", "评论", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.talkInfo.fscd03 = value;
          this.talkInfo.fscd02 = this.safeId;
          this.talkInfo.fscd04 = Number(localStorage.id);
          let params = {
            fromsafecomment: this.talkInfo,
          };
          AddFormComment(params).then((res) => {
            if (res.Code) {
              this.$message.success("你已评论成功!");
              // this.talkSafe = "";
              this.GetFormComment(this.safeId);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    // 删除评论
    async delTalk(id) {
      let params = {
        id,
      };
      let res = await DelFormComment(params);
      this.$message.success("你已成功删除评论！");
      this.GetFormComment(this.safeId);
    },
    // 查看表单内容
    lookForm(FormApplyFields) {
      this.lookFormShow = true;
      this.lookFromFields = FormApplyFields;
    },
    // 新增
    async AddFormApply() {
      let params = {
        name: this.functionName,
        tempId: this.functionTempId,
        qid: localStorage.pid,
        xid: localStorage.xid,
      };
      //撤回
      if (!this.functionName) {
        this.$message.error("请输入表单名称");
        return;
      }
      if (!this.functionTempId) {
        this.$message.error("请选择表单模板");
        return;
      }

      let fd = new FormData();
      for (var key in params) {
        fd.append(key, params[key]);
      }
      for (var i = 0, length = this.tempFields.length; i < length; i++) {
        var ele = this.tempFields[i];
        // 1文本 2音频 3视频 4表单编号 5金额 6是否选择项
        // 7填表人员 8提交时间 9附件 10视点 11选择集 12图片
        if (
          (ele.fmfd04 == 12 || ele.fmfd04 == 3 || ele.fmfd04 == 2) &&
          ele.fmfd02 != null
        ) {
          var ext = ele.fmfd02.name
            .substr(ele.fmfd02.name.lastIndexOf("."))
            .toLowerCase();
          if (
            ele.fmfd04 == 12 &&
            ext != ".png" &&
            ext != ".jpg" &&
            ext != ".jpeg"
          ) {
            this.$message.error("图片格式不正确！");
            return;
          } else if (ele.fmfd04 == 3 && ext != ".mp4" && ext != ".mov") {
            this.$message.error("视频格式不正确！");
            return;
          } else if (ele.fmfd04 == 2 && ext != ".mp3") {
            this.$message.error("音频格式不正确！");
            return;
          }
        }
        fd.append(ele.fmfd06, ele.fmfd02);
      }
      const loading = this.$loading({
        lock: true,
        text: "处理中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await AddFormApply(fd);
      loading.close();
      if (res.Code > 0) {
        this.$message.success("处理成功");
        this.addFormApplyOpen = false;
        this.GetFormApply();
      }
    },
    //查看和编辑
    async selFormApply(id, type) {
      let _this = this;
      this.safeId = id;
      this.updateFormApplyOpen = true;
      this.SubmitAuditParams.id = id;

      let res = await FindFormApplyDetail({ params: { id: id } });

      this.ApplyFieldsInfo = res.Data.FormApplyFields;
      this.FormApplyState = res.Data.FormApply.famp11; // FormApply
      this.formApplyDetil = res.Data;
      this.processStep = res.Data.FormAuditFlow.filter(
        (x) => x.fmad06 == res.Data.FormApply.famp09
      )[0];
      if (this.processStep.fmad10)
        this.boHuiStep = res.Data.FormAuditFlow.filter(
          (x) => x.fmad06 == this.processStep.fmad10
        )[0];

      //   发起人和审核人 编辑 需要筛选填写的内容
      //   这里对选择人员作处理，如果是选择人员需要把 string 转 Array
      if (type == 1) {
        this.formApplyDetil.FormApplyFields = res.Data.FormApplyFields.filter(
          (ele) => {
            return (
              ele.fafd04.split(",").includes("-1") &&
              localStorage.id == res.Data.FormApply.famp08
            );
          }
        ); //发起人 判断包含-1 并且当前用户id等于创建人id
      } else if (type == 2) {
        //查看
        // 除发起人之外的提交内容
        this.formApplyDetil.FormApplyFields = res.Data.FormApplyFields.filter(
          (ele) => {
            return ele.fafd04
              ? ele.fafd04.split(",").includes(localStorage.id.toString())
              : false;
          }
        );
      }
      //字段初始化
      this.formApplyDetil.FormApplyFields.forEach((ele) => {
        if (ele.fafd06 == null) {
          // 1文本 2音频 3视频 4表单编号 5金额 6是否选择项
          // 7填表人员 8提交时间 9附件 10视点 11选择集 12图片
          if (ele.fafd03 == 7) {
            //人员
            ele.fafd06 = localStorage.name;
          }
          if (ele.fafd03 == 4) {
            //编号,具有唯一性，使用时间，精确到毫秒
            ele.fafd06 = new Date().format("yyyyMMddhhmmssS");
          }
          if (ele.fafd03 == 8) {
            ele.fafd06 = new Date().format("yyyy-MM-dd hh:mm");
          }
        }
      });
    },
    async UpdateFormApply() {
      let fd = new FormData();
      for (
        var i = 0, length = this.formApplyDetil.FormApplyFields.length;
        i < length;
        i++
      ) {
        var ele = this.formApplyDetil.FormApplyFields[i];
        // 1文本 2音频 3视频 4表单编号 5金额 6是否选择项
        // 7填表人员 8提交时间 9附件 10视点 11选择集 12图片
        // if (ele.fafd03 == 2 && ele.fafd06 && typeof ele.fafd06 == "object") {
        //   ele.fafd06 = ele.fafd06.join(",");
        // }//不知道写的是啥注掉
        if (
          (ele.fafd03 == 12 || ele.fafd03 == 3 || ele.fafd03 == 2) &&
          ele.fafd06 != null
        ) {
          // 如果上传了新的图片
          if (ele.fafd06.name) {
            var ext = ele.fafd06.name
              .substr(ele.fafd06.name.lastIndexOf("."))
              .toLowerCase();
            if (
              ele.fafd03 == 12 &&
              ext != ".png" &&
              ext != ".jpg" &&
              ext != ".jpeg"
            ) {
              this.$message.error("图片格式不正确！");
              return;
            } else if (ele.fafd03 == 3 && ext != ".mp4" && ext != ".mov") {
              this.$message.error("视频格式不正确！");
              return;
            } else if (ele.fafd03 == 2 && ext != ".mp3") {
              this.$message.error("音频格式不正确！");
              return;
            }
          }
        }
        fd.append(ele.fafd05, ele.fafd06);
      }

      fd.append("qid", localStorage.pid);
      fd.append("id", this.formApplyDetil.FormApply.fmap01);
      const loading = this.$loading({
        lock: true,
        text: "处理中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await UpdateFormApplys(fd);
      loading.close();
      if (res.Code > 0) {
        this.$message.success("编辑成功");
        this.updateFormApplyOpen = false;
        this.GetFormApply();
      }
    },
    //催办
    async PressFormApply(id) {
      let res = await PressFormApply({ id });
      if (res.Code) {
        this.$message.success("催办成功");
        this.GetFormApply();
      }
    },
    //审核
    async SubmitAudit(type) {
      this.btnloading = true;
      let fd = new FormData();
      for (
        var i = 0, length = this.formApplyDetil.FormApplyFields.length;
        i < length;
        i++
      ) {
        var ele = this.formApplyDetil.FormApplyFields[i];
        if (
          (ele.fafd03 == 12 || ele.fafd03 == 3 || ele.fafd03 == 2) &&
          ele.fafd06 != null
        ) {
          if (ele.fafd06.name) {
            var ext = ele.fafd06.name
              .substr(ele.fafd06.name.lastIndexOf("."))
              .toLowerCase();
            if (
              ele.fafd03 == 12 &&
              ext != ".png" &&
              ext != ".jpg" &&
              ext != ".jpeg"
            ) {
              this.$message.error("图片格式不正确！");
              this.btnloading = false;
              return;
            } else if (ele.fafd03 == 3 && ext != ".mp4" && ext != ".mov") {
              this.$message.error("视频格式不正确！");
              this.btnloading = false;
              return;
            } else if (ele.fafd03 == 2 && ext != ".mp3") {
              this.$message.error("音频格式不正确！");
              this.btnloading = false;
              return;
            }
          }
        }
        fd.append(ele.fafd05, ele.fafd06);
      }
      if (type == 2) {
        this.$prompt("请输入内容", "拒绝内容", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }).then(async ({ value }) => {
          fd.append("content", value);
          fd.append("qid", localStorage.pid);
          fd.append("id", this.formApplyDetil.FormApply.fmap01);
          fd.append("type", type);
          const loading = this.$loading({
            lock: true,
            text: "处理中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          let res = await SubmitAudit(fd);
          this.btnloading = false;
          if (res.Code > 0) {
            this.$message.success("拒绝成功");
            this.updateFormApplyOpen = false;
            this.GetFormApply();
          }
          loading.close();
          this.btnloading = false;
        });
      } else {
        fd.append("content", "");
        fd.append("qid", localStorage.pid);
        fd.append("id", this.formApplyDetil.FormApply.fmap01);
        fd.append("type", type);
        const loading = this.$loading({
          lock: true,
          text: "处理中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let res = await SubmitAudit(fd);
        this.btnloading = false;
        loading.close();
        this.btnloading = false;
        if (res.Code > 0) {
          this.$message.success("处理成功");
          this.updateFormApplyOpen = false;
          this.GetFormApply();
        } else {
          this.$message.error(res.Message);
        }
      }
    },
    // 驳回
    async SubmitTurndown() {
      let fd = new FormData();
      for (
        var i = 0, length = this.formApplyDetil.FormApplyFields.length;
        i < length;
        i++
      ) {
        var ele = this.formApplyDetil.FormApplyFields[i];
        if (
          (ele.fafd03 == 12 || ele.fafd03 == 3 || ele.fafd03 == 2) &&
          ele.fafd06 != null
        ) {
          if (ele.fafd06.name) {
            var ext = ele.fafd06.name
              .substr(ele.fafd06.name.lastIndexOf("."))
              .toLowerCase();
            if (
              ele.fafd03 == 12 &&
              ext != ".png" &&
              ext != ".jpg" &&
              ext != ".jpeg"
            ) {
              this.$message.error("图片格式不正确！");
              this.btnloading = false;
              return;
            } else if (ele.fafd03 == 3 && ext != ".mp4" && ext != ".mov") {
              this.$message.error("视频格式不正确！");
              this.btnloading = false;
              return;
            } else if (ele.fafd03 == 2 && ext != ".mp3") {
              this.$message.error("音频格式不正确！");
              this.btnloading = false;
              return;
            }
          }
        }
        fd.append(ele.fafd05, ele.fafd06);
      }
      this.$prompt("请输入驳回内容", "驳回内容", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async ({ value }) => {
        fd.append("content", value);
        fd.append("qid", localStorage.pid);
        fd.append("id", this.formApplyDetil.FormApply.fmap01);
        const loading = this.$loading({
          lock: true,
          text: "处理中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let res = await SubmitTurndown(fd);
        if (res.Code > 0) {
          this.$message.success("驳回成功");
          this.updateFormApplyOpen = false;
          this.GetFormApply();
        }
        loading.close();
        this.btnloading = false;
      });
    },
    async GetFullFormTemp() {
      let params = {
        xid: localStorage.xid,
        functempId: JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
          .type,
      };
      let res = await GetFullFormTemp({ params });
      if (res.Data.length) {
        this.formTemplist = res.Data;
        this.formTemp = res.Data[0];
        this.AddFormApplyParams.tempId = res.Data[0].fmtp01;
        this.GetOneFormTemp(this.formTemp.fmtp01);
      }
    },
    GetOneFormTemp(id) {
      let params = {
        id,
        xid: localStorage.xid,
      };
      GetOneFormTemps({ params }).then((res) => {
        //   过滤发起人需要填写的
        this.tempFields = res.Data.tempFields.filter((ele) =>
          ele.fmfd05 ? ele.fmfd05.split(",").includes("-1") : false
        );
        this.tempFields.forEach((ele) => {
          ele.fmfd02 = null;
          // 1文本 2音频 3视频 4表单编号 5金额 6是否选择项
          // 7填表人员 8提交时间 9附件 10视点 11选择集 12图片
          if (ele.fmfd04 == 7) {
            //人员
            ele.fmfd02 = localStorage.name;
          }
          if (ele.fmfd04 == 4) {
            //编号,具有唯一性，使用时间，精确到毫秒
            ele.fmfd02 = new Date().format("yyyyMMddhhmmssS");
          }
          if (ele.fmfd04 == 8) {
            ele.fmfd02 = new Date().format("yyyy-MM-dd hh:mm");
          }
        });
      });
    },
    changeFile(item, file, type, type2) {
      let _this = this;
      if (type == 2) {
        item.fafd06 = file.raw;
        if (type2 == 2) {
          item.fafd06 = null;
        }
      } else {
        item.fmfd02 = file.raw;
        if (type2 == 2) {
          item.fmfd02 = null;
        }
      }
    },
    //查看动态记录
    Auditrecord() {
      this.record = true;
      this.formApplyDetil.FormAuditRecord.forEach((ele) => {
        if (ele.farc04 == "2" || ele.farc04 == "3") {
          ele.size = "large";
          ele.type = "danger";
          ele.icon = "el-icon-circle-close";
        } else {
          ele.size = "large";
          ele.type = "primary";
          ele.icon = "el-icon-circle-check";
        }
      });
    },
    opencomrecords() {
      this.comrecords = true;
      this.GetFormComment(this.SubmitAuditParams.id);
    },
    //查看协同流程
    openreviewpro() {
      this.reviewprocess = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？").then((_) => {
        done();
      });
    },

    tableRowClassName({ row, rowIndex }) {
      if (this.$route.params) {
        let index = this.formApplyList.findIndex(
          (ele) => ele.fmap01 == this.$route.params.fmap01
        );
        if (rowIndex === index) {
          return "warning-row";
        } else if (row.fmtp09 == 2) {
          return "danger-row";
        }
        return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
div#dataListRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #73b4af;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}
/deep/ .decrad .el-card__header {
  border-bottom: none;
  padding-bottom: 8px;
}
/deep/.el-table .warning-row {
  background: skyblue;
}
/deep/ .decrad .el-card {
  border: none;
}
/deep/ .goutong .el-card__body {
  padding: 0px;
}
.middle {
  margin-top: -30px;
  padding-top: 10px;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  height: 90vh;
}
.block {
  position: absolute;
  margin-top: 22px;
  margin-left: 30px;
}
/deep/.el-drawer.rtl {
  width: 25% !important;
}
.dia-card {
  .el-icon-bottom:before {
    content: "\E6EB";
    position: relative;
    margin-left: 17vh !important;
    font-size: 30px;
    top: 0px !important;
    color: #5db3f0;
  }
}
.el-body {
  p {
    color: #1177dc;
    font-size: 15px;
  }
}
.card-cont {
  text-align: center;
  margin-top: 18px;
  span {
    color: #838383;
  }
}
.div-span {
  position: relative;
  float: right;
  -webkit-transform: rotate(-30deg);
}
.el-timeline {
  position: relative;
  margin-left: 20px;
}
/deep/.card-choice {
  height: 80vh !important;
  .card-son {
    p {
      color: #1177dc;
      font-size: 15px;
    }
  }
}
.el-card__body {
  position: relative;
  padding: 20px;
  width: 35vh;
  .el-icon-bottom:before {
    content: "\E6EB";
    color: #5db3f0;
    font-size: 35px;
    position: relative;
    top: 3vh;
    margin-left: 15vh;
  }
}
/deep/.el-table .warning-row {
  background: skyblue;
}
/deep/.el-table .danger-row {
  background: #ffe98d;
}
</style>
